// src/components/AddImagesButton.jsx
import { useRef, useState } from 'react';

export function AddImagesButton({ onImagesAdd, maxImages = 5, currentImagesCount = 0 }) {
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileSelect = async (event) => {
    const files = Array.from(event.target.files);
    
    // Validar cantidad máxima
    if (currentImagesCount + files.length > maxImages) {
      alert(`Solo puedes tener máximo ${maxImages} imágenes. Ya tienes ${currentImagesCount}.`);
      return;
    }

    // Validar tipos de archivo
    const validFiles = files.filter(file => 
      file.type.startsWith('image/') && 
      file.size <= 5 * 1024 * 1024 // 5MB máximo
    );

    if (validFiles.length !== files.length) {
      alert('Algunos archivos no son imágenes válidas o son muy grandes (máx 5MB)');
    }

    if (validFiles.length > 0) {
      setIsUploading(true);
      try {
        await onImagesAdd(validFiles);
      } catch (error) {
        console.error('Error agregando imágenes:', error);
        alert('Error al agregar las imágenes: ' + error.message);
      } finally {
        setIsUploading(false);
        // Limpiar el input
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  const remainingSlots = maxImages - currentImagesCount;

  return (
    <div style={{ marginBottom: '16px' }}>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
        disabled={isUploading || remainingSlots <= 0}
      />

      <button
        type="button"
        onClick={triggerFileInput}
        disabled={isUploading || remainingSlots <= 0}
        style={{
          padding: '10px 16px',
          backgroundColor: remainingSlots <= 0 ? '#cbd5e1' : isUploading ? '#94a3b8' : '#00a680',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: remainingSlots <= 0 || isUploading ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
        onMouseEnter={(e) => {
          if (remainingSlots > 0 && !isUploading) {
            e.target.style.backgroundColor = '#059669';
          }
        }}
        onMouseLeave={(e) => {
          if (remainingSlots > 0 && !isUploading) {
            e.target.style.backgroundColor = '#00a680';
          }
        }}
      >
        {isUploading ? (
          <>
            <span>⏳</span>
            <span>Subiendo...</span>
          </>
        ) : (
          <>
            <span>📸</span>
            <span>Agregar Imágenes ({remainingSlots} disponibles)</span>
          </>
        )}
      </button>

      {remainingSlots <= 0 && (
        <p style={{ 
          margin: '8px 0 0 0', 
          fontSize: '12px', 
          color: '#64748b' 
        }}>
          ❌ Límite de {maxImages} imágenes alcanzado
        </p>
      )}
    </div>
  );
}